import { Component, inject, Input, SimpleChanges } from '@angular/core';
import { IconsAsignaturasService } from '../../../services/icons-asignaturas.service';
import { CommonModule } from '@angular/common';
import { AsignaturaItem, asignaturas, DataCore, filterData } from '../../../interface/data-core';
import { environment } from '../../../../environments/environment';
import { ASIGNATURA_COMPONENT_ID, agruparAsignaturas, FILTER_LABEL_ASIGNATURA, GRADOS_COMPONENT_ID, onAddClass, onScrollComponente, FILTER_LABEL_CLASS_ASIGNATURA, LISTADO_DINAMICO_ID, FILTER_LABEL_GRADO } from '../../../utils/generales';
import { CargarConfService } from '../../../services/cargar-conf.service';



@Component({
    selector: 'app-asignaturas',
    imports: [CommonModule],
    templateUrl: './asignaturas.component.html',
    styleUrl: './asignaturas.component.css'
})
export class AsignaturasComponent {
    @Input() public dataAsignaturas?: asignaturas[] = []; // Lista de asignaturas recibida como input
    @Input() public filtroSelecionados?: filterData;
    public _conf = inject(CargarConfService);

    public _icon_asignatura = inject(IconsAsignaturasService);


    public loggedIn = this._conf._auth.isAuthenticated();

    public asignaturas_label: string = environment.asignaturas_label || 'Asignaturas'; // Usar el label del environment o un valor por defecto
    public asignaturas_list: AsignaturaItem[] = [];

    constructor() {
    }

    ngOnInit() {
        this.init();

    }

    ngOnChanges(changes: SimpleChanges) {
        this.init();

    }

    init() {

        // Aquí podrías inicializar algo si es necesario
        this.asignaturas_list = agruparAsignaturas(this.dataAsignaturas || []);
        // console.debug('Asignaturas Component Initialized', this.asignaturas_list);
        // debugger

        this.asignaturas_list.map((asignatura, index) => {
            asignatura.icon = this._icon_asignatura.getIconByCssId(asignatura.clase ?? 'd_asig_def'); // Asignar el icono usando el servicio
            asignatura.clase = `${asignatura.clase}${!this.loggedIn ? ' d_inactiveicons' : ''}`;


            asignatura.action = () => {

                if (!this.loggedIn) {
                    return;
                }

                onAddClass(LISTADO_DINAMICO_ID, 'onHide');

                onAddClass(ASIGNATURA_COMPONENT_ID, 'onHide').then(() => {
                    this._conf.updateFilterField(FILTER_LABEL_CLASS_ASIGNATURA as keyof filterData, asignatura.clase ?? null);

                    setTimeout(() => {
                        onAddClass(GRADOS_COMPONENT_ID, 'd_firstsection');
                        onScrollComponente(GRADOS_COMPONENT_ID);
                    }, 50);
                });
                // Acción al hacer clic en la asignatura validar si solo existe un grado seleccionarlo
                if (this._conf.dataGlobalFiltrada?.grados.length === 1 && !this.filtroSelecionados?.grado) {
                    let [grado] = [...this._conf.dataGlobalFiltrada.grados];
                    this._conf.updateFilterField(FILTER_LABEL_GRADO as keyof filterData, grado.i ?? null);
                }

                //     console.debug(`Acción para la asignatura ${asignatura.label} con ID ${asignatura.listID}`);
            }
        });

        console.debug('Lista de asignaturas agrupadas', this.asignaturas_list);

        console.debug('Asignaturas de origen', this._conf.dataGlobal?.asignaturas, this.filtroSelecionados)


        //     if(this._conf.dataGlobal?.asignaturas.length === 1 && !this.filtroSelecionados?.class_asignatura){
        //     let [asignatura] = [...this.asignaturas_list]
        //     if(asignatura?.action)
        //         asignatura.action()
        //     }
    }


}
